import { CircularProgress } from '@mui/material';
import { StyledLoadingBox } from './styles';

export default function Loader() {
  return (
    <StyledLoadingBox>
      <CircularProgress />
    </StyledLoadingBox>
  );
}
